export default __webpack_public_path__ + "static/media/ERRIN_VulnerablePerson_comic.82601ebe.pdf";